import React, { type FormEvent } from 'react';

import { TopMessageVisibility } from 'src/constants/topMessageVisibility';
import { useStepContext } from 'src/contexts/stepContext/useStepContext';
import { useAppSelector } from 'src/store/reducers';

import type { AuthenticationRequirement } from '../../constants/authenticationRequirement';
import type { Metadata } from '../../types/MinHelseEntities';
import type { HNSkjemaFrontend } from '../../types/Resources';

import { RenderFormFillingInformation } from './GetFormFillingInformation';
import { RenderNotificationPanelMessage } from './RenderNotificatioinPanelMessage';
import { shouldFormBeDisplayedAsStepView } from '../stepView/utils';

export type TopMessageProps = {
  resources: HNSkjemaFrontend;
  authenticationRequirement?: AuthenticationRequirement;
  userMetadata: Metadata;
  printReference?: string;
  visibility?: number;

  openSidebar: (e: Event | FormEvent<unknown> | undefined) => void;
};

const TopMessage = (props: TopMessageProps): React.JSX.Element | null => {
  const { step } = useStepContext();

  const { isMicroweb, isMicrowebStep, isMicrowebOppgave, showTopMessageInMicroweb } = useAppSelector(state => state.microweb);
  const formDefinition = useAppSelector(state => state.refero.form.FormDefinition);

  const isMicrowebView = isMicroweb || isMicrowebStep || isMicrowebOppgave;
  const isStepView = formDefinition && shouldFormBeDisplayedAsStepView(formDefinition);

  const hide = props.visibility === TopMessageVisibility.Off;
  const hideInStepview = isStepView && step && step > 0;
  const hideInMicroweb = isMicrowebView && !showTopMessageInMicroweb;

  if (hide || hideInStepview || hideInMicroweb || !props.resources) {
    return null;
  }

  return (
    <div data-testid="top-message">
      <RenderNotificationPanelMessage {...props} resources={props.resources} />
      <RenderFormFillingInformation {...props} resources={props.resources} />
    </div>
  );
};

export default TopMessage;
